import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AccessMonitoringService } from '../access-monitoring.service';
import { AuditFilters, AuditResult } from '../models/access-monitoring.model';

@Component({
  selector: 'app-audit',
  templateUrl: './audit.component.html',
  styleUrls: ['./audit.component.scss']
})
export class AuditComponent implements OnInit, OnChanges {
  @Input() currentBookId: string = '';
  filterForm: FormGroup;
  auditResults: AuditResult[] = [];
  filteredAuditResults: AuditResult[] = [];
  agenzieList: string[] = [];
  loading = false;
  error: string | null = null;
  expandedRows: Set<string> = new Set();

  constructor(
    private fb: FormBuilder,
    private accessMonitoringService: AccessMonitoringService
  ) {
    this.filterForm = this.fb.group({
      dataCreazioneDa: [''],
      dataCreazioneA: [''],
      agenzia: [''],
      numeroPratica: [''],
      minutiDa: [''],
      minutiA: ['']
    });
  }

  ngOnInit(): void {
    this.loadAgenzie();
    this.loadAuditData();
  }

  ngOnChanges(): void {
    if (this.auditResults.length > 0) {
      this.filterByCurrentBookId();
    }
  }

  /**
   * Filtra i risultati audit per il bookId corrente
   */
  filterByCurrentBookId(): void {
    // if (this.currentBookId && this.currentBookId.trim() !== '') {
    //   this.filteredAuditResults = this.auditResults.filter(result => 
    //     result.numeroPratica === this.currentBookId
    //   );
    // } else {
    //   this.filteredAuditResults = this.auditResults;
    // }
    this.filteredAuditResults = this.auditResults;
  }

  /**
   * Carica lista agenzie per autocomplete
   */
  loadAgenzie(): void {
    this.accessMonitoringService.getAgenzie().subscribe({
      next: (response) => {
        if (response.success && response.data) {
          this.agenzieList = response.data;
        }
      },
      error: (error) => {
        console.error('Errore nel caricamento agenzie:', error);
      }
    });
  }

  /**
   * Carica i dati di audit
   */
  loadAuditData(): void {
    this.loading = true;
    this.error = null;

    const formValues = this.filterForm.value;

    // Crea l'oggetto filtri pulito
    const filters: AuditFilters = {};

    // Aggiungi solo i valori non vuoti
    if (formValues.dataCreazioneDa && formValues.dataCreazioneDa.trim() !== '') {
      filters.dataCreazioneDa = formValues.dataCreazioneDa;
    }

    if (formValues.dataCreazioneA && formValues.dataCreazioneA.trim() !== '') {
      filters.dataCreazioneA = formValues.dataCreazioneA;
    }

    if (formValues.agenzia && formValues.agenzia.trim() !== '') {
      filters.agenzia = formValues.agenzia;
    }

    if (formValues.numeroPratica && formValues.numeroPratica.trim() !== '') {
      filters.numeroPratica = formValues.numeroPratica;
    }

    if (formValues.minutiDa !== null && formValues.minutiDa !== undefined && formValues.minutiDa !== '') {
      const minutiDa = parseFloat(formValues.minutiDa);
      if (!isNaN(minutiDa)) {
        filters.minutiDa = minutiDa;
      }
    }

    if (formValues.minutiA !== null && formValues.minutiA !== undefined && formValues.minutiA !== '') {
      const minutiA = parseFloat(formValues.minutiA);
      if (!isNaN(minutiA)) {
        filters.minutiA = minutiA;
      }
    }

    console.log('Filtri applicati:', filters);

    this.accessMonitoringService.getAuditData(filters).subscribe({
      next: (response) => {
        this.loading = false;
        if (response.success && response.data) {
          this.auditResults = response.data;
          this.filterByCurrentBookId();
        } else {
          this.error = response.message || 'Errore nel caricamento dei dati';
        }
      },
      error: (error) => {
        this.loading = false;
        this.error = 'Errore nella chiamata al servizio';
        console.error('Errore:', error);
      }
    });
  }

  /**
   * Applica filtri
   */
  applyFilters(): void {
    this.loadAuditData();
  }

  /**
   * Resetta filtri
   */
  resetFilters(): void {
    this.filterForm.reset();
    this.loadAuditData();
  }

  /**
   * Espandi/comprimi riga dettagli
   */
  toggleRowExpansion(numeroPratica: string): void {
    if (this.expandedRows.has(numeroPratica)) {
      this.expandedRows.delete(numeroPratica);
    } else {
      this.expandedRows.add(numeroPratica);
    }
  }

  /**
   * Controlla se una riga è espansa
   */
  isRowExpanded(numeroPratica: string): boolean {
    return this.expandedRows.has(numeroPratica);
  }

  /**
   * Formatta durata in minuti
   */
  formatDuration(minutes: number): string {
    if (minutes < 60) {
      return `${minutes.toFixed(2)} min`;
    } else {
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;
      return `${hours}h ${remainingMinutes.toFixed(2)}min`;
    }
  }
}
